export const TOAST_MESSAGES = {
    PAYROLL_FETCH_FAILED: "Failed to fetch Payroll Data",
    PAYROLL_CREATED: " Payroll created successfully",
    PAYROLL_CREATE_FAILED: "Payroll create failed",
    PAYROLL_DELETE_ALERT: "Are you sure you want to delete this payroll.?",
    SUCCESS_DELETE_PAYROLL: "Payroll deleted successfully",
    FAILED_DELETE_PAYROLL: "Failed to delete Payroll",
    ERROR_DELETE_PAYROLL: "Error to delete payroll",
    UPDATE_PAYROLL_SUCCESS: "Update Payroll Successfully",
    UPDATE_PAYROLL_FAILED: "Failed to update payroll",
    SALARY_SLIPS_FETCH_FAILED: "Failed to fetch salary slip",
    UPDATE_SALARY_SLIP_FAILED: "Failed to update salary slip",
    UPDATE_SALARY_SLIP_SUCCESS: "Salary Slip updated",
    SALARY_SLIPS_FETCH: "Salary Slips Fetched",
    NOTIFICATION_SUCCESS: "Download notification sent successfully.",
    NOTIFICATION_FAILED: "Failed to send download notification.",
    PDF_DOWNLOAD_SUCCESS: "PDF Downloaded Successfully",
    PDF_DOWNLOAD_FAILED: "Error generating salary slip",
    PDF_TEMPLATE_LOAD_FAILED: "Failed to load PDF template.",
    PDF_TEMPLATE_LOADING: "Loading PDF template, please wait...",
    FAILED_TO_FETCH_REFERRALS: "Failed to Fetch Referrals"
}

export const PAYROLL_COLUMNS = [
    "username",
    "start_date",
    "end_date",
    "gross_salary",
    "conveyance_pct",
    "lta_pct",
    "esic_eligibility",
    "is_tds_applicable",
    "status",
    "action"
];

export const PAYROLL_LABELS = {
    username: "Employee Name",
    start_date: "Start Date",
    end_date: "End Date",
    gross_salary: "Monthly CTC",
    conveyance_pct: "Conveyance %",
    lta_pct: "LTA %",
    esic_eligibility: "ESIC Eligibility",
    is_tds_applicable: "TDS Applicable",
    status: "Status",
    action: "Action"
}

export const PAYROLL_STATUS = {
    PENDING_FOR_APPROVAL: "PENDING_FOR_APPROVAL",
    APPROVED: "APPROVED",
    REJECTED: "REJECTED",
};

export const PAYROLL_STATUS_OPTIONS = [
    { label: "Pending For Approval", value: "PENDING_FOR_APPROVAL" },
    { label: "Approved", value: "APPROVED" },
    { label: "Rejected", value: "REJECTED" },
];


export const getPayrollStatusColor = (status) => {
    switch (status) {
        case PAYROLL_STATUS.PENDING_FOR_APPROVAL:
            return "bg-yellow-50 hover:bg-yellow-150 transition-colors text-yellow-500";
        case PAYROLL_STATUS.APPROVED:
            return "bg-green-50 hover:bg-green-150 transition-colors text-green-500";
        case PAYROLL_STATUS.REJECTED:
            return "bg-red-50 hover:bg-red-150 transition-colors text-red-500";
        default:
            return "bg-white transition-colors text-black"; 
    }
};

export const SALARY_MASTER_MODE ={
    ADD: "Add",
    VIEW: "View",
}

export const ROLES = {
    ADMIN_ROLE: "ADMIN",
    HR: "HR",
    DIRECTOR_MANAGEMENT: "DIRECTOR_MANAGEMENT",
}

export const SALARY_SLIP_COLUMNS = [
    "username",
    "month",
    "net",
    "status",
    "action"
];

export const SALARY_SLIP_LABELS = {
    username: "Employee Name",
    month: "Month",
    net: "Net Salary" ,
    status: "Status",
    action: "Action"
}

export const SALARY_SLIP_STATUS = {
    INITIATED: "INITIATED",
    PENDING_FOR_APPROVAL: "PENDING_FOR_APPROVAL",
    APPROVED: "APPROVED"
};

export const SALARY_SLIP_STATUS_OPTIONS = [
    { label: "Initiated", value: "INITIATED" },
    { label: "Approved", value: "APPROVED" },
];

export const getSlipStatusColor = (status) => {
    switch (status) {
        case SALARY_SLIP_STATUS.INITIATED:
            return "bg-yellow-50 hover:bg-yellow-150 transition-colors text-yellow-500";
        case SALARY_SLIP_STATUS.APPROVED:
            return "bg-green-50 hover:bg-green-150 transition-colors text-green-500";
        case SALARY_SLIP_STATUS.PENDING_FOR_APPROVAL:
            return "bg-blue-50 hover:bg-blue-150 transition-colors text-blue-500";
        default:
            return "bg-white transition-colors text-black";
    }
};
